import { useEffect } from 'react';
import { teamsClient } from '../main';
import { logErrorMessage } from '../sentry/main';
export const useTeamsClientSetup = (stargateRoot, cloudId, orgId) => {
  useEffect(() => {
    if (!stargateRoot) {
      return;
    }
    teamsClient.setBaseUrl(stargateRoot);
  }, [stargateRoot]);
  useEffect(() => {
    teamsClient.setContext({
      cloudId,
      orgId
    });
    if (!orgId) {
      logErrorMessage(`No orgId set - useTeamsClientSetup`, {
        cloudId
      });
    }
  }, [cloudId, orgId]);
};